import {Injectable} from '@angular/core';
import {map, shareReplay} from 'rxjs/operators';

import {LpAssetDataService} from 'src/app/services/lp/lp-asset-data.service';
import {StorageService} from 'src/app/services/storage.service';
import {AppSettingsService} from 'src/app/services/app-settings.service';
import HoldingFileType from 'src/app/shared/enums/HoldingFileType.enum';
import {HoldingFileReqRes} from 'src/app/dashboard/shared/holding/HoldingFileReqRes.model';
import MetaFileLink from 'src/app/models/metaFileLink.model';
import {LocationDetailsResponse} from 'src/app/shared/models/LocationDetailsResponse.model';
import {LpAssetListItemReqRes} from './LpAssetListItemReqRes.model';
import {TerraUtils} from 'src/app/shared/TerraUtils';
import {Observable} from 'rxjs';
import {LpHoldingPositionRes} from '../models/LpHoldingPositionRes.model';
import {CurrencyModel} from '../../shared/models/CurrencyModel';

@Injectable()
export class LpAssetsService {

  assets$ = this.lpAssetDataService.getLpAssetsList();

  isUserRemovedExampleAsset = this.storageService.getPersistent<boolean>(this.storageService.IS_EXAMPLE_ASSET_REMOVED_LOCAL_STORAGE_KEY);

  // assetsWithExample$ = this.assets$.pipe(
  // map(assets => {
  //   const exampleAsset = this.getDummyAssetListItem();
  //   assets.unshift(exampleAsset);
  //   return assets;
  // }),
  // shareReplay(1));

  constructor(
    private lpAssetDataService: LpAssetDataService,
    private appSettingsService: AppSettingsService,
    private storageService: StorageService) {
  }

  getPendingAssetsList(): Observable<LpAssetListItemReqRes[]> {
    return this.lpAssetDataService.getPendingAssets();
  }

  getAssetsOpportunitiesList(): Observable<LpAssetListItemReqRes[]> {
    return this.lpAssetDataService.getAssetsOpportunities();
  }
}
